import React from 'react'
import { makeStyles } from '@material-ui/core'
import axios from 'axios';
import { CoinList, TrendingCoins } from  '../../apis/api';
import { useState } from 'react';
import { useEffect } from 'react';
import AliceCarousel from 'react-alice-carousel';
import {Link} from 'react-router-dom';

const useStyles = makeStyles((theme)=>({
    carousel:{
        height: "50%",
        display: "flex",
        alignItems: "center",
    },
    carouselItem: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer",
        textTransform: "uppercase",
        color: "white"
    }
}))

export function numberwithcommas(x){
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function Carousel() {
    const [trending, settrending] = useState([]);
    const classes = useStyles();
  
    const trendingCoins = async ()=>{
        const {data} = await axios.get(TrendingCoins('INR'));
        settrending(data);
    };

    console.log(trending);

    useEffect(() => {
      trendingCoins()
    }, []);

    let items = trending.map((coin)=>{
        let profit = coin.price_change_percentage_24h>=0;

        return(
            <Link className={classes.carouselItem} to={`/coins/${coin.id}`}>
                <img src={coin.image} alt={coin.name} height="80" style={{marginBottom: 10}} />
                {/* outer span for the symbol of coin */}
                <span>{coin.symbol}&nbsp; 
                    {/* inner span for the percentage change */}
                    <span style={{color:profit>0?"rgb(14,203,129)":"red",fontWeight:500,}}>
                        {profit && "+"} {coin.price_change_percentage_24h?.toFixed(2)}%
                    </span>
                </span>
                {/* span for the indian value of the coin */}
                <span style={{fontSize: 22,fontWeight: 500}}>
                    Rs. {numberwithcommas(coin.current_price.toFixed(2))}
                </span>
                
            </Link>
        )
    })

    const responsive = {
        0:{
            items: 2,
        },
        512: {
            items: 4,
        },
    }
    

    return (
    <div className={classes.carousel}>
        <AliceCarousel mouseTracking infinite autoPlayInterval={1000} animationDuration={1500} 
        disableDotsControls responsive={responsive} autoPlay items={items}/>
    </div>
  )
}

export default Carousel